export class MediaTypeParser {
    /** @inheritdoc */
    parseValue(rawValue) {
        if (typeof rawValue !== 'string')
            return undefined;
        return rawValue;
    }
}
// use a shared static instance for performance instead of
// instantiating a new instance for every use
MediaTypeParser.shared = new MediaTypeParser();
//# sourceMappingURL=mediatype.js.map